import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { ConsumerAdminService } from "../../../services/api/consumer-admin.service";
import { ConsumerAdminActions } from "../../actions/consumer-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class ConsumerUserCreateEffects {
	create = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerAdminActions.user.create),
			switchMap((action) =>
				this.consumerAdminService.inviteUser(action.request).pipe(
					map(() => ConsumerAdminActions.user.createSuccess()),
					catchError((error) =>
						of(ConsumerAdminActions.user.createFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private consumerAdminService: ConsumerAdminService
	) {}
}
